import React from 'react';
import { clsx } from 'clsx';
import classes from './SkeletonBox.module.css.js';
import '@styled-system/css';
import merge from 'deepmerge';

function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
const SkeletonBox = /*#__PURE__*/React.forwardRef(function SkeletonBox({
  height,
  width,
  className,
  style,
  ...props
}, ref) {
  return /*#__PURE__*/React.createElement("div", _extends({
    className: clsx(className, classes.SkeletonBox),
    style: merge(style, {
      height,
      width
    })
  }, props, {
    ref: ref
  }));
});

export { SkeletonBox };
